import { ASSETS, NAV_LINKS, CONTACT } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black py-16">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col items-start justify-between gap-12 md:flex-row md:items-center">
        <div className="flex items-center gap-4">
          <img src={ASSETS.logo} alt="Legacy Custom Homes" className="h-20 w-20 object-cover" />
          <div>
            <p className="font-accent text-sm font-semibold uppercase tracking-[0.3em] text-white">
              Legacy <span className="text-gold">Custom Homes</span>
            </p>
            <p className="mt-1 font-accent text-[10px] uppercase tracking-[0.25em] text-gray-500">
              Built to Last. Designed to Inspire.
            </p>
          </div>
        </div>

        <nav aria-label="Footer" className="flex flex-wrap gap-x-8 gap-y-3">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-accent text-[11px] font-medium uppercase tracking-[0.25em] text-gray-400 transition-colors duration-300 hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="font-accent text-[11px] uppercase tracking-[0.2em] text-gray-500">
          <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="block transition-colors duration-300 hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold">
            {CONTACT.phone}
          </a>
          <p className="mt-2">{CONTACT.area}</p>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
        <p className="text-xs text-gray-600">
          © {new Date().getFullYear()} Legacy Custom Homes. All rights reserved.
        </p>
        <p className="font-accent text-[10px] uppercase tracking-[0.25em] text-gray-600">
          Custom Homes · Renovations · Additions
        </p>
      </div>
    </div>
  </footer>
);
